module.exports = __webpack_public_path__ + "static/media/bp_logo_znak-10.9be2deef.svg";